<template>
  <div ref="listElement" :class="['market-list-item', { /* active: isActive,*/ wide: isWide, buyer:item.type=='buyer'}]" @click="goTo(item.id, $event)">

    <div :class="['header',  (item.type == 'seller')?'sale-header':(item.type == 'buyer')?'offer-header':'',{ 'with-owner': item.userId==props.userId}]">
      <div v-if="item.userId==props.userId" class="user-owner">
        <i>!</i>
        <span>Este anuncio es tuyo</span>
      </div>
      <span>anuncio de {{ (item.type == 'buyer')?'compra':'venta' }}</span>
    </div>

    <div class="market-list-item__product-img">
      <img v-if="item.type == 'buyer'" class="product-img" :src="getPalletImage(item.featureValues)" alt="Imagen del producto" />
      <img v-if="item.type == 'seller' && item.images.length==0" class="product-img no-photo" :src="NoFoto" alt="No hay fotografías" />
      <ImageSwiperComponent v-else-if="item.type == 'seller'" :images="item.images" type="BULLET"></ImageSwiperComponent>
    </div>

    <div class="market-list-item__content">
      <div class="user-content">
        <button class="name" @click="openUserModal($event)">
          <span>{{ item.userName }}</span>
          <i v-if="item.certifications?.length>0" class="bp-icon-Verified verified"></i>
        </button>
        <!-- <span class="name"></span> -->
        <img class="stars" :src="getStars(item.rating)" alt="Valoración" />
      </div>
      <div class="listing-content">
        <div v-for="(prop, index) in item.properties" :key="index"
             :class="['field', { bold: prop.highlighted,
                                  double: prop.size === 2},
                                  prop.styleMobile.toString().toLowerCase()]">
          <span class="field-label">{{ prop.label }}:</span>
          <span class="field-value">{{ prop.value }}</span>
        </div>
      </div>
    </div>
    <ModalComponent :visible="showUserModal" title="Información de usuario" @close="showUserModal=false">
      <template>
        <UserInfo :userId="userId"></UserInfo>
      </template>
    </ModalComponent>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount, defineProps } from "vue";
import { useRouter } from 'vue-router';
import ImageSwiperComponent from '@/components/common/ImageSwiperComponent/ImageSwiperComponent.vue';
import {MarketListItem} from "@/models/frontend/MarketModels";
import { getPalletImage } from "@/helpers/PalletImageHelper";
import NoFoto from "@/assets/images/default_images/No-foto.png";
import ModalComponent from "@/components/core/ModalComponent/ModalComponent.vue";
import UserInfo from "@/components/screens/User/UserInfoComponent.vue";
import { getStars } from "@/helpers/RatingHelper";

// eslint-disable-next-line no-unused-vars
const props = defineProps<{ item: MarketListItem, userId: string }>();
const isActive = ref(false);
const listElement = ref<HTMLElement | null>(null);
const isWide = ref(false);
const router = useRouter();
const showUserModal = ref(false);

const checkWidth = () => {
  if (listElement.value) {
    const elementWidth = listElement.value.offsetWidth; 
    isWide.value = elementWidth > 1024; 
  }
};

const goTo = (id: string, event: Event) => {
  const path = event.composedPath();

  if (path.some(el => el instanceof HTMLElement && el.classList.contains('swiper')) || path.some(el => el instanceof HTMLElement && el.classList.contains('name'))) {
    return;
  } else {
    isActive.value = true;
    router.push(`/listing/${id}`);
  }
};

const openUserModal = (e: Event) => {
  e.preventDefault();
  e.stopPropagation();
  showUserModal.value = true;
};

onMounted(() => {
  checkWidth();
  window.addEventListener("resize", checkWidth);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", checkWidth);
});
</script>

<style lang="scss" scoped>
@import 'MarketListItemComponent';
</style>